import React from "react";
import { render, screen, within } from "@testing-library/react";
import "@testing-library/jest-dom";
import { FullPageChatLayout } from "./FullPageChatLayout";

jest.mock("@metalmind-ab/mmagent-chat-ui", () => ({
  ChatMessage: ({ message }: { message: { content: string } }) => (
    <div>{message.content}</div>
  ),
  JobProgressIndicator: () => null,
  useChatStore: (selector: (state: object) => unknown) =>
    selector({
      backgroundJobs: [],
      removeBackgroundJob: jest.fn(),
      messages: [],
    }),
}));

beforeAll(() => {
  Object.defineProperty(HTMLElement.prototype, "scrollIntoView", {
    configurable: true,
    value: jest.fn(),
  });
});

describe("FullPageChatLayout over-cap message", () => {
  it("renders a non-editable, non-copyable placeholder rather than a chat bubble", () => {
    render(
      <FullPageChatLayout
        messages={[
          {
            id: "81",
            hubMessageId: 81,
            role: "system",
            content: "",
            createdAt: new Date(0),
            overCap: { kind: "over_cap", sizeClass: ">1.75 MB" },
          },
        ]}
        onSendMessage={jest.fn()}
        isLoading={false}
        conversations={[]}
        onLoadConversation={jest.fn()}
        onNewConversation={jest.fn()}
        onSearchConversations={jest.fn()}
        onLoadMoreConversations={jest.fn()}
        conversationsLoading={false}
        currentConversationId={1}
      />,
    );
    const card = screen.getByTestId("over-cap-message-81");
    expect(card).toHaveTextContent("This message is too large to display");
    expect(card).toHaveTextContent("ID: 81");
    expect(card).toHaveTextContent(">1.75 MB");
    expect(card).toHaveStyle({ userSelect: "none" });
    expect(within(card).queryByRole("button")).not.toBeInTheDocument();
    expect(within(card).queryByRole("textbox")).not.toBeInTheDocument();
  });
});
